import React from 'react';
import { AuthenticationsLayout } from '../../../../layouts/Authentications/AuthenticationsLayout';
import { Navigate, useSearchParams } from 'react-router-dom';
import useAuth from '../../../../../hooks/authentication/useAuth';
import { ForgotPasswordLandingForm } from '../../../../forgot-password/ForgotPasswordLandingForm';


export const ForgotPasswordLanding: React.FC = () => {

    const auth = useAuth();

    return (
        <>
            {auth.isLoggedIn && <Navigate to={'/'} replace />}
            {!auth.isLoggedIn && (
                <AuthenticationsLayout>
                    <ForgotPasswordLandingForm />
                </AuthenticationsLayout>
            )}
        </>
    );
};
